
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import UserGroups from '@/components/UserGroups.vue';
import { User } from '@/types';

@Component({
  components: {
    UserGroups,
  },
})
export default class LeadReassignDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false
  valid = false
  loading = false

  owners: number[] = []

  @Watch('value')
  onValueChange(val: boolean) {
    if (val === true) {
      this.owners = this.leadOwners;
    }
    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get user() {
    return this.$store.getters.currentUser;
  }

  get lead() {
    return this.$store.getters.currentLead;
  }

  get users() {
    return this.$store.getters.users;
  }

  get hasOwners() {
    return this.lead && Array.isArray(this.lead.owners) && this.lead.owners.length > 0;
  }

  get leadOwners() {
    return this.hasOwners
      ? this.lead.owners.map((u: User) => u.id)
      : [];
  }

  get noSelectedOwners() {
    return !this.owners
      || (Array.isArray(this.owners) && this.owners.length === 0);
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean };
  }

  onCancel() {
    this.dialog = false;
  }

  async onReassign() {
    if (this.form.validate()) {
      this.loading = true;

      await this.$store.dispatch('reassignLead', {
        owners: this.owners,
      });

      this.dialog = false;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    }
  }

  removeOwner(owner: User) {
    console.log('LeadReassignDialog: removeOwner() owner =', owner); // eslint-disable-line no-console

    const newOwners = this.owners.filter((ownerUserId) => ownerUserId !== owner.id);

    this.owners = newOwners;
  }
}
